const { useCatalogStore } = require('../storePinia/stores/catalog');

window.App.setStoreModules = function (modules) {
  if (typeof modules === 'object') {
    // eslint-disable-next-line guard-for-in
    for (const key in modules) {
      switch (key) {
        case 'footerMiniBanner':
        case 'personal':
        case 'basket':
        case 'favourite':
        case 'cities':
        case 'club':
          App.store.setStore(key, modules[key]);
          break;
        case 'catalog':
          useCatalogStore().$patch(modules[key]);
          break;
        default:
          console.warn('not registered ', key, modules[key]);
      }
    }
  }
};

App.vue.setComponent(require('@components/Catalog/CatalogSections/CatalogSections.vue').default);
